"use strict";

exports.__esModule = true;
exports["default"] = flatten;
var BASE = [];

function flatten() {
  return BASE.concat.apply(BASE, arguments);
}

module.exports = exports["default"];
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9mbGF0dGVuLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztxQkFFd0IsT0FBTztBQUYvQixJQUFNLElBQUksR0FBRyxFQUFFLENBQUE7O0FBRUEsU0FBUyxPQUFPLEdBQUk7QUFDakMsU0FBTyxJQUFJLENBQUMsTUFBTSxNQUFBLENBQVgsSUFBSSxFQUFXLFNBQVMsQ0FBQyxDQUFBO0NBQ2pDIiwiZmlsZSI6InNyYy9mbGF0dGVuLmpzIiwic291cmNlc0NvbnRlbnQiOlsiY29uc3QgQkFTRSA9IFtdXG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIGZsYXR0ZW4gKCkge1xuICByZXR1cm4gQkFTRS5jb25jYXQoLi4uYXJndW1lbnRzKVxufVxuIl19




/*****************
 ** WEBPACK FOOTER
 ** ./~/microcosm/flatten.js
 ** module id = 198
 ** module chunks = 0
 **/